module.exports = __webpack_public_path__ + "media/images/over-ons-6a0740018aad4b193cc713960b621d99.png";